import attention from "../../audio/attention.ogg";
import beep from "../../audio/beep.ogg";
import beep_error from "../../audio/beep_error.ogg";
import beep_warning from "../../audio/beep_warning.ogg";
import content_scanning from "../../audio/content_scanning.mp3";
import error from "../../audio/error.ogg";
import exchange from "../../audio/exchange.mp3";
import open_box from "../../audio/open_box.mp3";
import pickup from "../../audio/pickup.mp3";
import receive_error from "../../audio/receive-error.ogg";
import return_sound from "../../audio/return_sound.mp3";
import scanner_beep from "../../audio/scanner-beep.ogg";
import scanner_beep_charge from "../../audio/scanner-beep-charge.ogg";
import scanner_beep_major_scale_up from "../../audio/scanner-beep-major-scale-up.ogg";
import scanner_beep_major_scale_down from "../../audio/scanner-beep-minor-scale-down.ogg";
import scanner_beep_triple from "../../audio/scanner-beep-triple.ogg";
import schedule_delivery from "../../audio/scheduled_delivery.mp3";
import scheduled_pantry from "../../audio/scheduled_pantry.mp3";
import success from "../../audio/success.ogg";
import warn from "../../audio/warn.ogg";

const VIBRATION_DURATION = 500;

export const SoundType = Object.freeze({
    ATTENTION: attention,
    BEEP: beep,
    BEEP_ERROR: beep_error,
    BEEP_WARNING: beep_warning,
    CONTENT_SCANNING: content_scanning,
    ERROR: error,
    EXCHANGE: exchange,
    OPEN_BOX: open_box,
    PICKUP: pickup,
    RECEIVE_ERROR: receive_error,
    RETURN_SOUND: return_sound,
    SCANNER_BEEP: scanner_beep,
    SCANNER_BEEP_CHARGE: scanner_beep_charge,
    SCANNER_BEEP_MAJOR_SCALE_UP: scanner_beep_major_scale_up,
    SCANNER_BEEP_MAJOR_SCALE_DOWN: scanner_beep_major_scale_down,
    SCANNER_BEEP_TRIPLE: scanner_beep_triple,
    SCHEDULE_DELIVERY: schedule_delivery,
    SCHEDULED_PANTRY: scheduled_pantry,
    SUCCESS: success,
    WARN: warn,
});

export function playErrorSound() {
    playSound(SoundType.SCANNER_BEEP);
}

export function playWarningSound() {
    playSound(SoundType.BEEP_WARNING);
}

export function playSuccessSound() {
    playSound(SoundType.BEEP);
}

export function playSound(soundResource) {
    playAudio(soundResource);
    playVibration()
}

function playAudio(soundResource) {
    const audio = new Audio(soundResource);
    audio.play();
}

function playVibration() {
    window.navigator.vibrate(VIBRATION_DURATION);
}


// WEBPACK FOOTER //
// ./src/components/utils/SoundManager.js